<!-- Modern Quiz Component - Bootstrap 5.3.7 Layout -->
<div id="top" class="quiz-container py-4">

    <!-- Navigation Breadcrumb -->
  <div class="container-fluid py-2 bg-light border-bottom">
    <div class="container">
      <nav aria-label="breadcrumb" class="quiz-breadcrumb">
        <ol class="breadcrumb bg-transparent p-0">
          <li class="breadcrumb-item">
            <a href="/home" class="text-decoration-none">
              <i class="fa fa-home me-1"></i>{{ 'QUIZ.HOME' | translate }}
            </a>
          </li>
          <li class="breadcrumb-item">
            <a href="/classes" class="text-decoration-none">{{ 'QUIZ.CLASSES' | translate }}</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ 'QUIZ.QUIZ' | translate }} #{{ this.classId }}
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <!-- Class Header Card -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card border-0 shadow-sm quiz-header-card">
        <div class="card-body text-center py-4">
          <div class="d-flex align-items-center justify-content-center mb-3">
            <div class="quiz-icon-container me-3">
              <i class="fa fa-question-circle"></i>
            </div>
            <div>
              <h1 class="mb-1 quiz-title">
                {{ 'QUIZ.TITLE_PREFIX' | translate }} #{{ this.classId }}
              </h1>
              <p class="text-muted mb-0" *ngIf="this.class?.description">
                {{ this.class.description }}
              </p>
            </div>
          </div>
          
          <!-- Quiz Progress Indicator -->
          <div class="quiz-progress-container" *ngIf="quizQuestions && quizQuestions.length > 0">
            <div class="row align-items-center justify-content-center">
              <div class="col-auto">
                <span class="quiz-progress-label">{{ 'QUIZ.QUIZ_PROGRESS' | translate }}</span>
              </div>
              <div class="col-auto">
                <div class="progress quiz-progress-bar">
                  <div 
                    class="progress-bar bg-success" 
                    role="progressbar" 
                    [style.width]="getQuizProgress() + '%'"
                    [attr.aria-valuenow]="getQuizProgress()" 
                    aria-valuemin="0" 
                    aria-valuemax="100">
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <span class="quiz-progress-text">{{ getQuizProgress() }}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Quiz Questions Container -->
   <div class="quiz-section">
    <div class="container py-4">
      <div class="row">
        <div class="col-12">
          <div class="card border-0 shadow-sm quiz-content-card">
            <div class="card-body p-4">
              <!-- Quiz Instructions -->
              <div class="alert alert-info quiz-instructions mb-4" *ngIf="!this.quizcompleted">
                <div class="d-flex align-items-start">
                  <i class="fa fa-info-circle me-2 mt-1"></i>
                  <div>
                    <strong>{{ 'QUIZ.QUIZ_INSTRUCTIONS' | translate }}:</strong>
                    <p class="mb-0 mt-2">{{ 'QUIZ.QUIZ_INSTRUCTIONS_TEXT' | translate }}</p>
                  </div>
                </div>
              </div>
    
              <!-- Quiz Questions -->
              <div class="quiz-questions-container">
                <div class="row row-cols-1 row-cols-lg-2 g-4">
                  <ng-container *ngFor="let quizQuestion of quizQuestions; let i = index">
                    <div class="col" *ngIf="this.previousQuestion != quizQuestion.question">
                      <div class="card border quiz-question-card h-100">
                        <div class="card-header bg-light border-bottom">
                          <div class="d-flex align-items-center">
                            <span class="question-number me-3 text-dark"></span>
                            <h5 class="question-text mb-0">
                              {{ quizQuestion.question }}
                              {{ addCorrectAnswer(quizQuestion.quizQuestionId, quizQuestion.correctAnswer) }}
                            </h5>
                          </div>
                        </div>
                        
                        <div class="card-body d-flex flex-column">
                          <!-- Answer Choices -->
                          <div class="answer-choices flex-grow-1">
                            <div class="form-check answer-choice mb-3" *ngFor="let choice of quizQuestion.choises">
                              <input
                                class="form-check-input quiz-radio"
                                type="radio"
                                [name]="choice.quizQuestionId"
                                [value]="choice.choiceLetter"
                                [id]="'choice_' + choice.quizQuestionId + '_' + choice.choiceLetter"
                                (change)="addStudentAnswer(quizQuestion.quizQuestionId, $event)"
                              />
                              <label 
                                class="form-check-label answer-label"
                                [for]="'choice_' + choice.quizQuestionId + '_' + choice.choiceLetter">
                                <span class="choice-letter">{{ choice.choiceLetter }}.</span>
                                <span class="choice-text">{{ choice.choiceAnswer }}</span>
                              </label>
                            </div>
                          </div>
    
                          <!-- Error Messages -->
                          <div class="quiz-feedback mt-auto" *ngIf="checkErrorQuestion(quizQuestion.quizQuestionId)">
                            <div class="alert alert-danger d-flex align-items-start">
                              <i class="fa fa-times-circle me-2 mt-1"></i>
                              <div>
                                <strong>{{ 'QUIZ.INCORRECT_ANSWER' | translate }}</strong>
                                <p class="mb-0 mt-1">{{ quizQuestion.correctAwnser }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {{ updateQuestion(quizQuestion.question) }}
                    </div>
                  </ng-container>
                </div>
              </div>
    
              <!-- Quiz Completion Message -->
              <div class="quiz-completion-message text-center py-4" *ngIf="this.quizcompleted">
                <div class="completion-icon mb-3">
                  <i class="fa fa-check-circle text-success"></i>
                </div>
                <h3 class="text-success mb-3">{{ 'QUIZ.CONGRATULATIONS' | translate }}</h3>
                <p class="text-muted">{{ 'QUIZ.CONGRATULATIONS_MESSAGE' | translate }}</p>
              </div>
    
              <!-- Action Buttons -->
              <div class="quiz-actions text-center mt-4">
                <button 
                  class="btn btn-primary btn-lg quiz-submit-btn" 
                  *ngIf="!this.quizcompleted"
                  (click)="validateQuiz()">
                  <i class="fa fa-paper-plane me-2"></i>
                  {{ 'QUIZ.SUBMIT_BUTTON' | translate }}
                </button>
    
                <button 
                  class="btn btn-success btn-lg quiz-continue-btn" 
                  *ngIf="this.quizcompleted"
                  (click)="continue()">
                  <i class="fa fa-arrow-right me-2"></i>
                  {{ 'QUIZ.CONTINUE_BUTTON' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   </div>
  
</div>

<!-- Modern Success Modal -->
<ng-template #content let-modal>
  <div class="modal-header border-0 quiz-modal-header">
    <div class="d-flex align-items-center">
      <div class="modal-icon me-3">
        <i class="fa fa-trophy"></i>
      </div>
      <h4 class="modal-title mb-0" id="modal-basic-title">
        {{ 'QUIZ.MODAL_TITLE' | translate }}
      </h4>
    </div>
    <button
      type="button"
      class="btn-close btn-close-white"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')">
    </button>
  </div>
  
  <div class="modal-body p-4">
    <div class="text-center">
      <div class="success-animation mb-4">
        <i class="fa fa-check-circle text-success"></i>
      </div>
      
      <div class="congratulations-text">
        <h5 class="mb-3">{{ 'QUIZ.MODAL_CONGRATULATIONS' | translate }}</h5>
        <p class="text-muted mb-3">{{ 'QUIZ.MODAL_COMPLETED_ALL' | translate }}</p>
        <div class="certificate-info">
          <i class="fa fa-certificate text-warning me-2"></i>
          <span>{{ 'QUIZ.MODAL_CERTIFICATE_EMAIL' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal-footer border-0 justify-content-center">
    <button
      type="button"
      class="btn btn-success btn-lg px-4"
      (click)="modal.close('Save click')">
      <i class="fa fa-check me-2"></i>
      {{ 'QUIZ.MODAL_CLOSE' | translate }}
    </button>
  </div>
</ng-template>

<style>
.quiz-modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.modal-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-icon i {
  font-size: 1.5rem;
  color: #ffd700;
}

.success-animation i {
  font-size: 4rem;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.certificate-info {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 0.5rem;
  padding: 1rem;
  color: #856404;
}
</style>
